import { gql } from "@apollo/client";

export const GET_SIDEMENU = gql`
  query GetSideMenu($department: Int, $role: Int, $orgId: Int) {
    getSideMenu(department: $department, role: $role, orgId: $orgId) {
      screens
    }
  }
`;
export const GET_ALLSIDEMENU = gql`
  query GetAllSideMenu($orgId: Int) {
    getAllSideMenu(orgId: $orgId) {
      department
      role
      screens
      orgId
    }
  }
`;
export const CREATE_SIDEMENU = gql`
  mutation CreateSideMenu($input: createSideMenuInput) {
    createSideMenu(input: $input) {
      department
    }
  }
`;

export const UPDATE_SIDEMENU = gql`
  mutation updateSideMenu($input: updateSideMenuInput) {
    updateSideMenu(input: $input)
  }
`;
